import React, { useEffect, useState } from 'react'
import { Box, Grid, InputLabel, TextField } from '@material-ui/core';
import { Autocomplete as MuiAutocomplete } from "@material-ui/lab";
import OptionItem from '../../models/OptionItem';


interface InputProps {
    label: string;
    name: string;
    value?: OptionItem;
    multiValue?: OptionItem[];
    placeholder: string;
    maxLength?: number;
    multiple?: boolean;
    mandatory?: boolean;
    error: any;
    options?: OptionItem[];
    onChange: (e: any) => void;
    onBlur?: (e: any) => void;
}
 

export default function Autocomplete(props: InputProps) {

    const { label, error = null, name, options, multiple, placeholder, onChange, onBlur, mandatory = null } = props;

    const [value, setValue] = useState<OptionItem>({ Id: 0, Value: "0", Text: "" });

    const [valueMultiple, setValueMultiple] = useState<OptionItem[]>([]);

    const convertToDefEventPara = (name: string, value: any) => ({
        target: {
            name, value
        }
    })

    useEffect(() => {
        if (!multiple) {
            if (!props.value || props.value == null || props.value?.Id === 0) {
                setValue({ Id: 0, Value: "0", Text: "" })
            } else if (options != null && (props.value?.Id > 0 || props.value?.Id.toString().length > 0)) {
                setValue(props.value)
            }
        } else {
            if (props.multiValue) {
                setValueMultiple(props.multiValue)
            }
        }
    }, [props.value, props.multiValue, multiple, options])

    const handleAutocompleteChange = (event: any, newValue: any) => {
        onChange(convertToDefEventPara(name, newValue))
        setValue(newValue)
    };

    const handleAutocompleteMultipleChange = (event: any, newValue: any) => {
        onChange(convertToDefEventPara(name, newValue))
        setValueMultiple(newValue)
    };

    //OBS: Método usando apenas para renderizar a mensagem de erro ao passar pelo campo. A seleção do campo dispara o evento de OnChange (handleAutocompleteChange)
    const handleOnBlurChange = (newValue: any) => {
        if (onBlur && newValue.target.value === "") {
            onBlur(convertToDefEventPara(name, newValue.target.value))
            setValue(newValue.target.value)
        }
    };

    return (
        <React.Fragment>
            {multiple ?
                <Box mt={1}>
                    <InputLabel {...(error && { error: true })} style={{ "color": (!error ? '#000' : '') }}>{label}{mandatory ? " *" : ""}</InputLabel>
                    <MuiAutocomplete
                        multiple
                        noOptionsText={'Resultado não encontrado'}
                        options={options ? options : []}
                        getOptionLabel={(option) => option.Text}
                        getOptionSelected={(option, value) => option.Id === value.Id}
                        value={valueMultiple}
                        onChange={handleAutocompleteMultipleChange}
                        renderInput={(params) => (
                            <Grid>
                                <TextField
                                    {...params}
                                    error={error !== ""}
                                    name={name}
                                    helperText={error}
                                    placeholder={placeholder}
                                    fullWidth
                                />
                            </Grid>
                        )}
                    />
                </Box>
                :
                <Box mt={1}>
                    <InputLabel {...(error && { error: true })} style={{ "color": (!error ? '#000' : '') }}>{label}{mandatory ? " *" : ""}</InputLabel>
                    <MuiAutocomplete
                        options={options ? options : []}
                        noOptionsText={'Resultado não encontrado'}
                        getOptionLabel={(option: any) => option.Text ? option.Text : ""}
                        getOptionSelected={(option, value) => {
                            if (!value || value.Id === 0) {
                                return true;
                            } else if (option.Id === value.Id) {
                                return true;
                            } else {
                                return false;
                            }
                        }}
                        openOnFocus
                        value={value}
                        onChange={handleAutocompleteChange}
                        onBlur={handleOnBlurChange}
                        renderInput={(params) => (
                            <Grid>
                                <TextField
                                    {...params}
                                    error={error !== ""}
                                    name={name}
                                    helperText={error}
                                    placeholder={placeholder}
                                    fullWidth
                                />
                            </Grid>
                        )}
                    />
                </Box>
            }
        </React.Fragment>
    )
}

